import styled from 'styled-components';

export const StyledText = styled.div`
    text-align: left;
`;
